import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Heal extends Bloc {

	constructor (src, ctx) {

		super("heal", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [];
			let amount = ins[1] === undefined || ins[1] === null ? ins[0].maxhp : ins[1];
			let restrictedRecovery = src.recovery && !src.fullRecoveryActive && ins[0] === src.master.player;
			if (restrictedRecovery)
				amount = src.recoveryHealAmount(amount, ins[0]);
			let recovered = Math.min(amount, ins[0].maxhp - ins[0].hp);
			ins[0].heal(amount);
			if (restrictedRecovery && recovered > 0)
				src.master.notify("recoveryheal", src, recovered);
			return [];
		};
		this.types = [Types.entity, Types.int];
	}
}
